import { ElMessage, ElMessageBox } from 'element-plus'


function clickLink(link) {
    const urlRegex = /^http(s)?:\/\//;
    console.log('link', link)
    if (urlRegex.test(link)) {
        window.open(link, '_blank')
    }
    return false;
}

function successMessge(msg) {
  ElMessage('msg')
}

export {
  clickLink,
  successMessge
}